import React from 'react'

import { useSelector } from 'react-redux'
import Stack from '@mui/material/Stack'

import { FormSectionTitle } from '../../FormComponents/FormSectionTitle'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'
import { OpportunityName } from '../../FormComponents/OpportunityName/OpportunityName'

export function OpportunitySection() {
  const services = useSelector(selectAllLeadOppProducts)

  return (
    <Stack gap={2} pb={2}>
      <FormSectionTitle>Opportunity</FormSectionTitle>
      <OpportunityName services={services} initialValue="" />
    </Stack>
  )
}
